/********************* Libaraies ***********************/
import ViewTicket from "customer/orders/myBooking/component/viewTicket";
import { t } from "i18next";
import moment from "moment";
import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ActionsPanelComponent from "shared/component/dxf-grid/actions-panel.component";
import DxfGrid from "shared/component/dxf-grid/dxf-grid";
import OrderHeader from "shared/component/orderHeader/orderHeader";
import { client } from "shared/helpers/client";
import { formatDate } from "shared/helpers/utils";
import useModal from "shared/hooks/useModel";
import { BookingOfficeSource } from "./office-booking.service";
import { downloadTicketBillPdf } from "shared/services/reportService";
import Close from "shared/assets/images/svg/close_dialog.svg";
import { Column } from "devextreme-react/data-grid";


const BookingModal = ({ show, onHide, bookingOfficeSource, name, ...props }) => {
  const { t } = useTranslation();
  const handleSortDate = useCallback((sortBy) => {
    let start = moment(sortBy.from).format();
    let end = moment(sortBy.to).format();
    bookingOfficeSource.searchValue([["StartDate", "=", `${start}`], "and", ["EndDate", "=", `${end}`]]);
    bookingOfficeSource.reload();
  }, []);
  return (
    <div>
     
      <Modal
            fullscreen
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            className="all-modal Admin-modal"
        >
            <Modal.Body>
                <div className="header">
                        <h1 className="title office-title">{name}</h1>
                    <img src={Close} alt="close-modal" onClick={onHide} />
                </div>
                <hr className="hr" />
                <div className="">
            <div className="container-fluid">
              <OrderHeader  handleSortDate={handleSortDate} />
              <div className="dataTable">
                <DxfGrid
                  dataSource={bookingOfficeSource}
                >
                    <Column dataField="paxName" caption={t('my-booking.name')} />
            <Column dataField="issueDate"  caption={t('my-booking.issue')} cellRender= {(data) => formatDate(data.value)} />
            <Column dataField="airLine" width='250' caption={ t('my-booking.airline')}  />
            <Column dataField="ticketNumber" caption={t('my-booking.ticket')} />
            <Column dataField="pnr" caption={t('my-booking.pnr')} />
            <Column dataField="status" caption={ t('my-booking.status')}  />
            <Column dataField="netTotal" width='250' caption={t('my-booking.total')}/>
            <Column   cellRender={(cell) => <UserActions cell={cell}  />} />
                </DxfGrid>
              </div>
            </div>
          </div>
            </Modal.Body>
        </Modal>
    </div>
  );
};
export function UserActions({ cell }) {
  const row = cell.data;
  const [viewTicket, openTicket, closeTicket] = useModal(false);
  const [ticket, setTicket] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  async function handleViewTicket() {
    openTicket();
    const { response } = await client("/OwnerBooking/GetTicketDetails", {
      params: { TicketNumber: row?.ticketNumber },
    });
    if (response) {
      setTicket(response);
    }
  }
  async function handlePrint() {
    setIsPrinting(true);
    await downloadTicketBillPdf(row?.id);
    setIsPrinting(false);
  }
  function getActions() {
    return [
      {
        label: "View Ticket",
        action: () => handleViewTicket(),
      },
      { label: isPrinting ? "Printing..." : "Print", action: handlePrint },
      { label: "Send By E-mail", action: () => console.log(row) },
    ];
  }

  return (
    <>
      <ActionsPanelComponent actions={getActions()} />
      <ViewTicket ticketData={ticket} show={viewTicket} onHide={closeTicket} />
    </>
  );
}
export default BookingModal;
